import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import replacement from '../../../../images/game-fact/banc-remplaçants.png'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'
import { GAME_FACT_REPLACEMENT, reasonListRugbyReplacement  } from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'
import RecapTotalMinutesPlayed from '../recapGeneric/RecapTotalMinutesPlayed.js'

const RecapReplacement = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
  const {team, timer, outplayer, inplayer, period, reason, text} = state
  
  const [img] = useGameFact({type : GAME_FACT_REPLACEMENT})

  const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

  let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

  let inPlayer = allPlayers.find(p => p._id === inplayer) ?? EMPTY_PLAYER
  let outPlayer = allPlayers.find(p => p._id === outplayer) ?? EMPTY_PLAYER

  let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

  const actualPeriod = period ??  match.period

  // Gestion du text
  useEffect(() => {
    if(!state.text || state.edited){
        const monText = 'Remplacement de '+outPlayer.lastname+' par '+inPlayer?.lastname+'. '+(reason && reason !== 'normal' ? "Raison : "+reasonListRugbyReplacement.find(r => r.id === reason).value : '')
        
        if(!inHistory)
          onChangeText && onChangeText(monText)
    }

    if(!state.title || state.edited){
      const monTitle = 'REMPLACEMENT'
      
      if(!inHistory){
          onChangeTitle && onChangeTitle(monTitle)
      }
          
  }
}, [])

  // TODO replace by totalMinPlayed new GF
  if (text && text.includes('Minutes jouées')) {
    return RecapTotalMinutesPlayed({state, match, onChangeText, onChangeTitle, inHistory});
  }

  return (
    <div style={{color : inHistory ? 'black' : 'white'}}>
      <img src={img} width={150}/>
      <Typography>Equipe : {teamSelected.name}</Typography>
      <Typography>Joueur sortant : {outPlayer.lastname}</Typography>
      <Typography>Joueur rentrant : {inPlayer?.lastname}</Typography>
      <Typography>Raison : {reason && reasonListRugbyReplacement.find(r => r.id === reason).value}</Typography>
      {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}

      {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
      {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
    </div>
  )
}

export default RecapReplacement